<template>
  <div class="app-tariff-option-modal-wrapper">
    <TariffChangeBookingModal
      :show.sync = showProp
      :content = modalContent
      :actions = "createActions(selectedOption)"
      :btn-already-clicked="btnAlreadyClicked"
      :automatic-extension="selectedOption.automaticExtension"
      @click:booking="booking()"
      @click:deactivate="deactivate(selectedOption)"
    >
      <template v-for="slot in possibleChildSlotsFor('Modal', selectedOption.tariffoptionId)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffChangeBookingModal>
  </div>
</template>
<script>
import TariffChangeBookingModal from '@/components/process/generic/Tariff/generic/TariffChangeBookingModal.vue'
import durationUnit from '@/mixins/durationUnit'
import slotProxy from '@/mixins/slotProxy'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import price from '@/mixins/price'
import { mapActions } from 'vuex'

export default {
  name: 'TariffOptionModalWrapper',
  components: { TariffChangeBookingModal },
  data () {
    return {
      show: false,
      selectedOption: [],
      bookTariffoptionDocumentUrl: null,
      currentCustomer: {
        balance: null
      },
      requiresContractSummary: null,
      showContract: null,
      btnAlreadyClicked: false
    }
  },
  mixins: [
    durationUnit,
    price,
    slotProxy()
  ],
  computed: {
    modalContent: function () {
      return {
        title: this.selectedOption.name,
        detailBoxes: this.createDetails(this.selectedOption),
        slotData: this.createSlotData(this.selectedOption),
        documentUrl: (this.bookTariffoptionDocumentUrl && (this.showContract || this.showContract === null)) ? this.bookTariffoptionDocumentUrl : null,
        message: {
          type: this.createMessageType(this.selectedOption)
        }
      }
    },
    showProp: {
      get: function () {
        return this.show
      },
      set: function () {
        this.show = false
        this.$emit('close')
      }
    },
    doubleDataPromo: function () {
      return [
        'CCS_92055',
        'CCS_92056',
        'CCS_92057'
      ]
    }
  },
  methods: {
    ...mapActions('bookTariffOptions', [
      'confirmTariffoption', 'deactivateTariffOption', 'cancelTariffOptionConfirm'
    ]),
    booking () {
      this.btnAlreadyClicked = true
      const me = this
      this.confirmTariffoption({}).then(() => {
        me.$emit('refresh')
        this.show = false
        this.btnAlreadyClicked = false
      }, () => {
        this.show = false
        this.btnAlreadyClicked = false
      })
    },
    deactivate (option) {
      this.btnAlreadyClicked = true
      const me = this
      this.cancelTariffOptionConfirm().then((success) => {
        if (success) {
          me.$store.commit('addMessage', { type: 'success', message: 'Tarifoption erfolgreich gekündigt' })
          me.$emit('refresh')
        }
        this.show = false
        this.btnAlreadyClicked = false
      }, () => {
        this.show = false
        this.btnAlreadyClicked = false
      })
    },
    showBookedModal (option, optionList, bookTariffoptionDocumentUrl = null) {
      this.show = true
      const baseUrl = this.$config.apiUrl
      this.bookTariffoptionDocumentUrl = (bookTariffoptionDocumentUrl !== null ? baseUrl + '' + bookTariffoptionDocumentUrl : null)
      this.selectedOption = optionList?.find(el => {
        return (el.tariffoptionId === option)
      })
    },
    showBookingModal (bookingInformation, option, optionList) {
      const baseUrl = this.$config.apiUrl
      if (bookingInformation.bookTariffoptionDocumentUrl) {
        this.bookTariffoptionDocumentUrl = baseUrl + '' + bookingInformation.bookTariffoptionDocumentUrl
      }
      this.show = true
      this.selectedOption = optionList?.find(el => {
        return (el.tariffoptionId === option)
      })
      if ('requiresContractSummary' in this.selectedOption) {
        this.showCotract = this.selectedOption.requiresContractSummary
      }
    },
    createActions (option) {
      if (this.deactivatable(option)) {
        return [
          {
            type: 'deactivate',
            text: 'Option kündigen',
            disabled: this.btnAlreadyClicked
          }
        ]
      }
      if (this.activatable(option)) {
        return [
          {
            type: 'booking',
            text: 'Option kostenpflichtig buchen',
            disabled: this.disableButton(option)
          }
        ]
      }
      return null
    },
    isBalanceLow (option) {
      return option.price > this.currentCustomer.balance
    },
    activatable (option) {
      return option.__typename === 'BookableTariffoption' && !option.cancelable && !this.doubleDataPromo.includes(option.tariffoptionId)
    },
    deactivatable (option) {
      return option.__typename === 'BookedTariffoption' && option.cancelable && option.statusKey !== 'TER' && !this.doubleDataPromo.includes(option.tariffoptionId)
    },
    createMessageType (option) {
      if (this.isBalanceLow(option) && option.automaticExtension && this.activatable(option)) {
        return 'Automatic'
      } else if (this.isBalanceLow(option) && this.activatable(option)) {
        return 'NotBookable'
      } else if (this.deactivatable(option)) {
        return 'Deactivateable'
      } else if (this.activatable(option)) {
        return 'Bookable'
      }
    },
    createDetails (option) {
      let secondary = option.duration?.amount === 0 ? null : '/' + option.duration?.amount + ' ' + this.durationUnit(option.duration?.unit.toUpperCase(), option.duration?.amount)
      if (option.tariffoptionId === 'CCS_92050') {
        secondary = '/ 03.01.2024'
      }

      return [
        ...option.tariffExtra?.volumes || [],
        {
          primary: option.formattedPrice,
          secondary: secondary
        }]
    },
    createSlotData (option) {
      return {
        name: option.name,
        formattedPrice: option.formattedPrice,
        duration: this.durationUnit(option.duration?.unit.toUpperCase(), option.duration?.amount),
        amount: option.duration?.amount,
        balance: this.price(this.currentCustomer.balance),
        endOfRuntime: option.possibleChangingDate ? option.possibleChangingDate : null,
        bandwidth: option.bandwidth
      }
    },
    disableButton (option) {
      if (this.btnAlreadyClicked) {
        return this.btnAlreadyClicked
      } else {
        return this.isBalanceLow(option) && !option.automaticExtension
      }
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query tariffOptions {
        currentCustomer {
          balance
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
